import React, { useEffect, useState } from "react";

const Footer = () => {
  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);
  return (
    <div className="footer bg-teal-700 py-6">
      <div className="container mx-auto">
        <p className="text-white text-center text-sm">
          Copyright © {currentYear} ESWaap.com All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
